export const AdminRole = {
  PRODUCTION_ADMIN: 'Production.Admin',
  PRODUCTION: 'Production',
  BILLING: 'Billing',
  RESOURCE_ADMIN: 'Resource.Admin',
  SCHEDULING_ADMIN: 'Scheduling.Admin',
  ASSIGNER: 'Assigner',
} as const;

export type AdminRoleValue = typeof AdminRole[keyof typeof AdminRole];

// Role groupings for permission checks
export const JOBS_ROLES: AdminRoleValue[] = [AdminRole.PRODUCTION_ADMIN, AdminRole.PRODUCTION, AdminRole.BILLING];
export const RESOURCES_WRITE_ROLES: AdminRoleValue[] = [AdminRole.RESOURCE_ADMIN];
export const SCHEDULING_ROLES: AdminRoleValue[] = [AdminRole.SCHEDULING_ADMIN, AdminRole.ASSIGNER];
export const SCHEDULING_ADMIN_ONLY: AdminRoleValue[] = [AdminRole.SCHEDULING_ADMIN];
export const ALL_ADMIN_ROLES: AdminRoleValue[] = Object.values(AdminRole);
